import { render } from "./Fullname.vue?vue&type=template&id=7038c7c4"
import script from "./Fullname.vue?vue&type=script&lang=js"
export * from "./Fullname.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__